
<div>
    <app-bar :title="content.name"/>

    <v-layout>
        <v-progress-linear
            v-if="overlay"
            absolute
            indeterminate
        ></v-progress-linear>

        <div class="pt-8 pb-12 px-8">
            <div class="pb-10">
                <v-btn
                    v-if="permitted('admin_club_management')"
                    @click="edit"
                    class="sm mr-5"
                    color="primary"
                >{{ t('general_action_edit') }}
                </v-btn>
                <v-btn
                    v-if="permitted('admin_club_management')"
                    class="sm mr-5"
                    color="primary"
                    outlined
                    @click.prevent="suspend(content)"
                >
                    {{ content.enabled ? t('general_action_suspend') : t('general_action_unsuspend') }}
                </v-btn>
                <confirm-modal
                    v-if="permitted('admin_club_management')"
                    :title="t('general_title_confirm_action')"
                    @agree="del(content)"
                >
                    <template #default="{ on, attrs }">
                        <v-btn
                            class="sm"
                            color="orange"
                            outlined
                            v-on="on"
                            v-bind="attrs"
                        >{{ t('general_action_delete') }}</v-btn>
                    </template>
                </confirm-modal>
            </div>
            <div class="float-left mr-10" style="width: 394px; max-width: 394px">
                <img
                    v-if="content.photoUrl"
                    :src="content.photoUrl"
                    width="150"
                />
                <div class="form-subtitle">{{ t('club_content_label_description') }}:</div>
                <div class="form-subtitle-description" v-html="content.description"></div>
                <div v-if="content.videoUrl" class="form-subtitle">{{ t('club_content_label_video_url') }}:</div>
                <div v-if="content.videoUrl" class="form-subtitle-description">{{ content.videoUrl }}</div>
            </div>
            <div class="float-left" style="max-width: calc(100% - 434px)">
                <card-unit :items="items()">
                    <template #title>{{ t('club_content_label_id') }}: {{ content.id }}</template>
                </card-unit>
            </div>
        </div>
    </v-layout>
</div>
